import { Injectable } from '@angular/core';
import { AppVersion } from '@ionic-native/app-version';
import { Platform } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';

@Injectable()
export class AppVersionProvider {

    version:string;

    constructor(private appVersion: AppVersion, private platform: Platform) { }

    async getVersionNumber() {

        try {
            if (this.platform.is('cordova'))
                this.version = (await this.appVersion.getVersionNumber()).toString();
        } catch (ex) {
            LoggerProvider.info(this, 'Failed to retrieve app version');
            LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to retrieve version.');
        }
        if (!this.version) {
            this.version = HttpProvider.version;
        }

        return this.version;
    }
}



// WEBPACK FOOTER //
// ./src/providers/app-version/app-version.ts